const actions = {
  // ------------ log in / out ---------------
  CHECK_AUTHORIZATION: 'CHECK_AUTHORIZATION',
  SET_REDIRECT_AFTER_LOGIN: 'SET_REDIRECT_AFTER_LOGIN',
  LOGIN_REQUEST: 'LOGIN_REQUEST',
  LOGIN_WITH_OTP_REQUEST: 'LOGIN_WITH_OTP_REQUEST',
  LOGIN_REQUIRES_OTP: 'LOGIN_REQUIRES_OTP',
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  LOGIN_ERROR: 'LOGIN_ERROR',
  LOGOUT: 'LOGOUT',
 
  
  // --------- log in /out stuff ------------
  checkAuthorization: () => ({ 
    type: actions.CHECK_AUTHORIZATION,
  }),
  login: (username, password, rememberMe) => ({
    type: actions.LOGIN_REQUEST,
    username,
    password,
    rememberMe,
  }),
  loginWithOtp: (username, password, rememberMe, otpCode) => ({
    type: actions.LOGIN_WITH_OTP_REQUEST,
    username,
    password,
    rememberMe,
    otpCode
  }),
  logout: () => ({
    type: actions.LOGOUT
  }),
  
};
export default actions;
